import React from "react";

export default function ChallengeDetailQuestions({ questions }) {
    if (!questions?.length) return null;
    return (
        <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-2 flex items-center justify-between">
                <span>Questions ({questions.length})</span>
            </div>
            <div className="space-y-3">
                {questions.map((q, qi) => (
                    <div
                        key={q.id}
                        className="border border-white/10 bg-black/60"
                        data-testid={`question-${qi}`}
                    >
                        <div className="px-3 py-2 border-b border-white/5 flex items-center justify-between">
                            <span className="font-mono text-[10px] uppercase tracking-widest text-fa-yellow">
                                Q{qi + 1} · {q.type.replace("_", " ")}
                            </span>
                            <span className="font-mono text-[10px] text-white/40">
                                select {q.choices_min_selections}
                                {q.choices_max_selections !== q.choices_min_selections
                                    ? `–${q.choices_max_selections}`
                                    : ""}
                            </span>
                        </div>
                        <div className="px-3 py-2 text-sm font-display font-bold uppercase tracking-tight">
                            {q.text}
                        </div>
                        <div className="px-3 pb-3 space-y-1">
                            {q.choices?.map((c, ci) => (
                                <div
                                    key={ci}
                                    className="bg-[#0a0a0a] border border-white/5 px-2 py-1.5"
                                >
                                    <div className="font-display font-bold uppercase text-sm">
                                        {c.text}
                                    </div>
                                    {c.description && (
                                        <div className="text-xs text-white/70 leading-snug mt-0.5">
                                            {c.description}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
